export function formatNumberWithSpaces(
  value: number | string | null | undefined,
): string {
  if (!value) return "";

  const numericValue = typeof value === "number" ? value.toString() : value;
  const [integer, decimal] = numericValue.split(".");
  const formatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return decimal !== undefined ? `${formatted}.${decimal}` : formatted;
}

export const formatOrgNr = (
  value: number | string | null | undefined,
): string => formatNumberWithSpaces(value);

export const formatPercentage = (
  value: number | string | null | undefined,
): string => {
  if (value === null || value === undefined || value === "") return "";
  if (Number.isNaN(value)) return "";
  return `${Number(value).toLocaleString("no-NO", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} %`;
};
